import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
const Inventory = (props) => {
    return(
      <tr>
        <td>
          <NavLink to={`/inventory/${props.inventory.id}/`}>
            {props.inventory.id}
          </NavLink>
        </td>
        <td>{props.inventory.item.name}</td>
        <td className="hidden-xs-down"><span className="badge badge-pill badge-warning">{props.inventory.station.name}</span></td>
        <td className="hidden-xs-down">{props.inventory.current_location}</td>
        {props.is_ingredient? null:<td>{(props.inventory.extra_info && props.inventory.extra_info.grade)? props.inventory.extra_info.grade.grade: 'N/A'}</td>}
        <td className="hidden-xs-down">{props.inventory.brand? props.inventory.brand.brand_name : ''}</td>
        <td>
          <div className="d-flex">
            <span>{props.is_ingredient? props.inventory.actual_weight : props.inventory.weight}</span>
            <span className="measureUnit ml-025">
              <span className="badge badge-pill badge-info"> {props.inventory.item.measure_unit? props.inventory.item.measure_unit : 'kg'}</span>
            </span>
          </div>
        </td>
        {props.is_ingredient? null: <td className="hidden-xxs-down">{props.inventory.number_items}</td>}
        <td className="hidden-xs-down">{props.inventory.packing_date}</td>
        {props.is_ingredient?
          <td><div className="d-flex">
            <a className="btn btn-danger color-white mr-0 m-0" onClick={()=>props.on_delete_item(props.inventory.id)}><i className="fa fa-trash"></i></a>
          </div></td>:null
        }
      </tr>
    )
}

export default class InventoryList extends Component {
  render() {
    return (
        <tbody>
          {this.props.inventories.inventories.results && this.props.inventories.inventories.results.map((inventory,index)=>{
            return(
              <Inventory on_delete_item={(id)=>this.props.openModal(id)} inventory={inventory} key={index} is_ingredient={this.props.is_ingredient}/>
            )
          })}
        </tbody>
    )
  }
}
